import React, { createContext, useContext, useState, useEffect } from 'react';
import apiService from '../services/api';

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  // Single Location Mode - Multi-location code commented for future use
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load single location on mount
  useEffect(() => {
    loadSingleLocation();
  }, []);

  const loadSingleLocation = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // FRONTEND-ONLY MODE: Backend API call commented out
      // Try to get locations from API, use first one - COMMENTED OUT
      // const data = await apiService.locations.getAll();
      // if (data && data.length > 0) {
      //   // Use first active location or first location
      //   const activeLocation = data.find(loc => loc.is_active) || data[0];
      //   setSelectedLocation(activeLocation);
      //   setLocations([activeLocation]); // Keep single location in array for compatibility
      // } else {
      //   // Fallback: Single default location for Naga's Boutique
      //   const defaultLocation = {
      //     id: 1,
      //     name: "Naga's Boutique",
      //     address: 'Store Address',
      //     city: 'Hyderabad',
      //     phone: '+91-8341745188',
      //     is_active: true,
      //   };
      //   setSelectedLocation(defaultLocation);
      //   setLocations([defaultLocation]);
      // }
      
      // FRONTEND-ONLY MODE: Use default location directly
      const defaultLocation = {
        id: 1,
        name: "Naga's Boutique",
        address: 'Store Address',
        city: 'Hyderabad',
        phone: '+91-8341745188',
        is_active: true,
      };
      setSelectedLocation(defaultLocation);
      setLocations([defaultLocation]);
    } catch (err) {
      console.error('Error loading location:', err);
      setError('Failed to load location');
      
      // Fallback: Single default location
      const defaultLocation = {
        id: 1,
        name: "Naga's Boutique",
        address: 'Store Address',
        city: 'Hyderabad',
        phone: '+91-8341745188',
        is_active: true,
      };
      setSelectedLocation(defaultLocation);
      setLocations([defaultLocation]);
    } finally {
      setLoading(false);
    }
  };

  // Multi-location change function - commented for single location mode
  // const changeLocation = (location) => {
  //   setSelectedLocation({ ...location });
  //   localStorage.setItem('selectedLocationId', location.id);
  //   console.log('📍 Location changed to:', location.name, '(ID:', location.id, ')');
  // };

  // Single location mode - no change function needed
  const changeLocation = () => {
    // No-op for single location
    console.log('Single location mode - location change not available');
  };

  return (
    <LocationContext.Provider value={{
      locations,
      selectedLocation,
      loading,
      error,
      changeLocation,
      reloadLocations: loadSingleLocation, // Single location mode
    }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};
